module.exports = __webpack_public_path__ + "static/media/yellow-brick-road.5110c477.png";